import WelcomePage from "./welcomePage";
import LoginPage from "./loginPage";
import PasswordPage from "./passwordPage";
import CreateConferencePage from "./createConferencePage";

export { WelcomePage, LoginPage, PasswordPage, CreateConferencePage };
